import React from "react";
import Dropdown from "core/components/Dropdown/Dropdown";
import { FilterProps } from "modules/filters/components/SwitchFilter";

function CreatorFilter<T extends object>({
  filterValue = [],
  setFilter,
  name,
  defaultValues,
}: FilterProps<T, string[]>) {
  if (!setFilter) {
    return null;
  }
  const creatorsOptions = defaultValues?.map((value: string) => ({
    value,
    label: value,
  }));

  const onChange = (
    selectedOptions: Array<{ value: string; label: string }>
  ) => {
    setFilter(selectedOptions.map((option) => option.value));
  };

  const filterOptions = filterValue.map((value: string) => ({
    value,
    label: value,
  }));

  return (
    <Dropdown
      disabled={false}
      options={creatorsOptions}
      name={name!}
      value={filterOptions}
      onChange={onChange}
      isMulti
    />
  );
}

export default CreatorFilter;
